'use client';

import React from 'react';
import styled from 'styled-components';

interface LockedFeatureProps {
  message?: string;
  className?: string;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #9ca3af;
`;

const LockIcon = styled.svg`
  width: 16px;
  height: 16px;
  color: #9ca3af;
`;

/**
 * LockedFeature Component
 * 
 * Displays a lock icon with message for premium features
 */
export const LockedFeature: React.FC<LockedFeatureProps> = ({
  message = 'Available only in Solo, Team and Enterprise.',
  className,
}) => {
  return (
    <Container className={className}>
      <LockIcon viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
      </LockIcon>
      <span>{message}</span>
    </Container>
  );
};

export default LockedFeature;

